module.exports = __webpack_public_path__ + "img/P.ff7a5818.png";